<template>
    <div class="vue-accordion-wrapper vue-accordion accordion-wrapper">
        <div class="title" :class="{'open':isOpen}" @click="isOpen = !isOpen">
            <slot name="title"></slot>
        </div>
        <div class="items enable-overflow" @slide-open-end="enableOverflow($event, true)" @slide-close-start="enableOverflow($event,false)" v-show-slide="isOpen">
            <slot name="items"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "MediaAccordion",

    props: {
      overflowEnabled: {
          type: Boolean,
          default: false,
      }
    },

    data() {
        return {
            isOpen: true,
        }
    },

    methods: {
        enableOverflow({target}, enable) {
            if (!this.overflowEnabled) {
                return;
            }

            if (enable) {
                return target.classList.add('enable-overflow')
            }

            return target.classList.remove('enable-overflow');
        }
    }
}
</script>
